import {
  Button,
  Col,
  EditButton,
  Form,
  getDefaultSortOrder,
  Icons,
  Input,
  List,
  Row,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import {
  CrudFilters,
  IResourceComponentsProps,
  useTranslate,
} from "@pankod/refine-core";
import { ButtonExport } from "components/buttonExport";
import useMediaScreen from "hooks/useMediaScreen";
import { ContributorSubscriptionPoolList } from "pages/contributorSubscriptionPool";
import React from "react";
import { IPackage, IPackageResponse } from "types/package.interface";
import { formatNumberWith2DecimalPlaces, getOrderNumber } from "utils";

export const SubscriptionPackageList: React.FC<
  IResourceComponentsProps
> = () => {
  const t = useTranslate();
  const { isMobile } = useMediaScreen();
  const { tableProps, sorter, searchFormProps }: any =
    useTable<IPackageResponse>({
      resource: "subscription-packages",
      initialPageSize: 100,
      onSearch: (params) => {
        const filters: CrudFilters = [];
        const input = params;
        filters.push({
          field: "search",
          operator: "in",
          value: input,
        });
        return filters;
      },
    });
  const current = tableProps?.pagination?.current;
  const pageSize = tableProps?.pagination?.pageSize;

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <ContributorSubscriptionPoolList />
      </div>
      <List>
        <Row style={{ display: "block" }}>
          <Col>
            <Form layout="vertical" {...searchFormProps}>
              <Form.Item
                label="Search"
                name="search"
                style={{ width: isMobile ? "100%" : "50%" }}
                initialValue=""
              >
                <Input placeholder="Name" prefix={<Icons.SearchOutlined />} />
              </Form.Item>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Form.Item>
                  <Button htmlType="submit" type="primary">
                    Filter
                  </Button>
                </Form.Item>
                <ButtonExport path="subscription-packages" />
              </div>
            </Form>
          </Col>
          <Col>
            <Table
              {...tableProps}
              pagination={{
                ...tableProps?.pagination,
                showSizeChanger: true,
              }}
              rowKey="id"
            >
              <Table.Column
                dataIndex="_id"
                key="_id"
                title="Index"
                render={(value, item, index) => (
                  <TextField value={getOrderNumber(current, pageSize, index)} />
                )}
              />
              <Table.Column
                dataIndex="name"
                key="name"
                title="Name"
                render={(value) => <TextField value={value} />}
                defaultSortOrder={getDefaultSortOrder("name", sorter)}
                sorter={(a: any, b: any) => a.name.localeCompare(b.name)}
              />
              <Table.Column
                dataIndex="price"
                key="price"
                title="Price ($)"
                render={(value) => (
                  <TextField value={formatNumberWith2DecimalPlaces(value)} />
                )}
                defaultSortOrder={getDefaultSortOrder("price", sorter)}
                sorter={(a: any, b: any) => a.price - b.price}
              />
              <Table.Column
                dataIndex="numberOfPurchases"
                key="numberOfPurchases"
                title="# Of Purchases"
                render={(value, record) => (
                  <a href={`/subscription-packages/edit/${record._id}`}>
                    <TextField value={value || 0} />
                  </a>
                )}
                defaultSortOrder={getDefaultSortOrder(
                  "numberOfPurchases",
                  sorter
                )}
                sorter={(a: any, b: any) =>
                  a.numberOfPurchases - b.numberOfPurchases
                }
              />
              <Table.Column
                dataIndex="recurringDays"
                key="recurringDays"
                title="# Recurring Days"
                render={(value) => <TextField value={value} />}
                sorter={(a: any, b: any) => a.recurringDays - b.recurringDays}
              />
              <Table.Column
                dataIndex="maxDownloadsPerMonth"
                key="maxDownloadsPerMonth"
                title="Max Download Per Month"
                render={(value) => <TextField value={value} />}
                sorter={(a: any, b: any) =>
                  a.maxDownloadsPerMonth - b.maxDownloadsPerMonth
                }
              />
              <Table.Column
                dataIndex="planId"
                key="planId"
                sorter={(a: any, b: any) => a.planId.localeCompare(b.planId)}
                title="Subscription Plan ID"
                render={(value) => <TextField value={value} />}
              />
               <Table.Column
                dataIndex="isActive"
                key="isActive"
                sorter={(a: any, b: any) => String(a.isActive).localeCompare(String(b.isActive))}
                title="is active"
                render={(value) => <TextField value={value ? "Yes" : "No"}/>}
              />
              
              <Table.Column
                dataIndex="isLimitAccess"
                key="isLimitAccess"
                title="Limit Access"
                render={(value) => <TextField value={value ? "Yes" : "No"} />}
              />
              <Table.Column<IPackage>
                title={t("table.actions")}
                dataIndex="actions"
                render={(_, record) => (
                  <Space>
                    <EditButton
                      hideText
                      size="small"
                      recordItemId={record._id}
                    />
                    {/* <DeleteButton
                      hideText
                      size="small"
                      recordItemId={record._id}
                    /> */}
                  </Space>
                )}
              />
            </Table>
          </Col>
        </Row>
      </List>
    </>
  );
};
